import { useState } from 'react';

const IGNORED_INTERACTIONS_KEY =
  'interactionsWithContactsIntegrationBannerIgnored';

const getIgnoredInteractionIdsFromStorage = (): Record<string, boolean> => {
  const localStorageObject = localStorage.getItem(IGNORED_INTERACTIONS_KEY);
  return localStorageObject
    ? (JSON.parse(localStorageObject) as Record<string, boolean>)
    : {};
};

const setIgnoredInteractionIdsInStorage = (
  interactionsMap: Record<string, boolean>,
): void => {
  localStorage.setItem(
    IGNORED_INTERACTIONS_KEY,
    JSON.stringify(interactionsMap),
  );
};

export const useIgnoredInteractionIdsForContactBanner = () => {
  const [ignoredInteractionIds, setIgnoredInteractionIds] = useState(
    getIgnoredInteractionIdsFromStorage(),
  );

  const ignoreBannerForInteractionId = (id: string) => {
    const newIgnoredIds = { ...ignoredInteractionIds, [id]: true };
    setIgnoredInteractionIds(newIgnoredIds);
    setIgnoredInteractionIdsInStorage(newIgnoredIds);
  };

  const isBannerIgnoredForInteractionId = (id: string) => {
    return !!ignoredInteractionIds[id];
  };

  return {
    isBannerIgnoredForInteractionId,
    ignoreBannerForInteractionId,
  };
};
